import { styles, TabBarItemTheme, variants } from '../TabBarItemStyles.css';
import { baseTheme } from './TabBarItemBaseTheme.css';
import { multiVariantStyles } from './TabBarItemVariants.css';

const TabBarItemRedwoodTheme: TabBarItemTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { TabBarItemRedwoodTheme };
